import React from "react";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";

const SelectAllBoardMenuItem = ({
  selectAll,
  checked = false,
  label = "All Boards",
  className = "",
  ...props
}) => {
  return (
    <>
      <CustomMenuItem onClick={selectAll || null} className={className}>
        <label className="custom-checkbox">
          <input
            type="checkbox"
            id={`board-list-my-task-checkbox-all-board`}
            onClick={(event) => {
              event.stopPropagation();
            }}
            checked={checked}
            onChange={()=>{}}
            {...props}
          />
          <span className="checkmark"></span>
          {label}
        </label>
      </CustomMenuItem>
    </>
  );
};

export default SelectAllBoardMenuItem;
